export default {
  pageTitle: '広告認証',
  management: 'アカウント認証管理',
  point: {
    management: 'トラッカー管理',
  },
  authRange: {
    router: {
      confirm: {
        ok: '認証',
        goPl: '制作へ',
      },
      nodata: {
        title: 'データを表示できません',
        noplaceDesc:
          '現在プレイアブルはありません。新しく作成することができます。',
        desc: '承認されたアカウントのデータ範囲はすべて「取得しない」に設定されているため、データが表示できません。アカウントごとにデータ範囲を変更するには、承認管理ページに移動してデータ範囲を変更してからデータを表示してください。',
      },
      noadv: {
        tooltip:
          'このプラットフォームでは広告アカウントが認証されていません。データを表示するには、「共通設定」-「認証管理」で広告アカウントを認証してください。',
        title: 'まだどのプラットフォームアカウントも承認されていません',
        desc: '広告アカウントを承認してから、クリエイティブインサイトモジュールでデータを表示できます。',
      },
      noReport: {
        tooltip:
          'このチャンネルは広告パフォーマンスデータをサポートしておらず、インタラクションデータのみを含みます。',
      },
      norange: {
        title: '広告アカウントの素材データ範囲が設定されていません',
        desc: '承認されたアカウントの素材データ範囲がまだ設定されておらず、設定してからクリエイティブインサイトにアクセスできます。設定するには、承認管理ページに移動してください。',
      },
      channel: {
        nodata: {
          title: 'データが表示できません',
          desc: 'このプラットフォームのすべてのアカウントのデータ範囲が「取得しない」に設定されているため、データが表示できません。このプラットフォームのデータを表示するには、承認管理ページに移動してデータを取得する範囲を変更してから表示してください。',
        },
      },
    },
    settingDialog: {
      title: 'アカウントの素材データ範囲の設定',
      desc: 'すでに承認されたアカウントの素材データ範囲が設定されていません。Playturboが取得できるサードパーティプラットフォームの各アカウントのデータ範囲を設定してください。',
      form: {
        col: {
          trafficType: {
            title: 'チャネル',
          },
          accountName: {
            title: 'アカウント名',
          },
          dataRange: {
            title: 'データ範囲',
          },
        },
      },
    },
    updateDialog: {
      title: 'データ範囲の設定',
    },
    settting: {
      success: '設定成功',
    },
  },
  authPage: {
    description:
      'アカウント認証管理とインタラクティブ素材トラッキング管理の統合',
  },
  authLabel: '認証',
  authDialog: {
    quickAuth: {
      desc: 'クリックして取得',
      label: 'アカウント情報',
      tips: '現在のアカウントのメールに対応するMintegtal広告プラットフォームのアカウント情報を入力してください。',
    },
    title: 'アカウントの認証',
    agreement: '「認証契約」',
    guideText: '操作ガイド',
    secret: '確認し同意しました',
    form: {
      dataRange: {
        label: 'データ範囲',
        part: 'Playturboで制作したクリエイティブ',
        forbidden: '取得しない',
        all: '全クリエイティブ',
        tipsLabel:
          'タイムゾーン：この広告プラットフォームのメインアカウントのタイムゾーンに従います。更新時間：対応するタイムゾーンの02:00に前日のデータが更新されます。',
      },
    },
  },
  table: {
    pushAccountName: 'プッシュアカウント名',
    action: {
      pushInfo: 'クリエイティブ情報をプッシュ',
      manage: 'サブアカウント管理',
      bind: '許可',
      unbind: '認証解除',
      delete: '削除',
      assistAccount: 'アシストアカウント管理',
    },
    column: {
      assist: 'アシスト',
      email: 'メール',
      account: 'アカウント',
      status: 'ステータス',
      action: '操作',
    },
    account: {
      sign: {
        main: 'メインアカウント',
        sub: 'サブアカウント',
      },
    },
    pushId: 'プッシュ履歴ID',
    pushChannel: 'プッシュチャネル',
    search: {
      email: 'メール',
      accountName: 'アカウント名',
      status: 'ステータス',
      authTime: '認証日時',
    },
  },
  accountDialog: {
    table: {
      column: {
        accountName: 'アカウント名',
        traffic_type: 'プラットフォーム',
        authTime: '認証日',
      },
    },
    info: {
      channel: 'プラットフォーム',
      email: 'メインアカウントのメール',
      accountName: 'メインアカウント名',
    },
    title: 'サブアカウント管理',
  },
  pushInfoDialog: {
    table: {
      column: {
        pushdownload: 'ダウンロード/プッシュステータス',
        id: '素材ID',
        name: '素材名',
      },
    },
  },
  bindtips: {
    title: '再認証',
    content: ' {name}を{channel}プラットフォーム向けに再認証しますか？',
    confirm: '権限',
  },
  deletetips: {
    title: '本当に削除しますか？',
    desc: '{channel} プラットフォーム向けの {name} を削除しますか？',
    confirm: '削除',
  },
  auth: {
    error: {
      tips: '権限の状態に問題があります。新しい権限を追加して再度このプラットフォームアカウントに権限を付与できます。',
    },
    success: {
      message: '権限を取得しました',
    },
    dataRange: {
      tips: 'Playturboが生成したクリエイティブデータのみを取得',
    },
    cancel: {
      title: '認証解除',
      desc: '認証解除すると、そのアカウントに素材をプッシュすることができなくなり、そのアカウントからデータを取得することもできなくなります。本当に認証解除しますか？',
      confirm: '認証解除',
      cancel: '保留',
    },
  },
  delete: {
    success: {
      message: '削除成功',
    },
  },
  authStatus: {
    active: '権限取得済',
    unbound: '権限キャンセル',
    disabled: '権限エラー',
    pending: '認証中',
    unactive: '権限なし',
  },
  assistAccountDialog: {
    title: 'アシストアカウント管理',
    addBtn: 'アシストアカウントを追加',
    table: {
      name: 'アカウント名',
      type: 'タイプ',
      assistantAccount: 'アシストアカウント',
      action: '操作',
    },
    closeBtn: '閉じる',
  },
  addAssistAccountDialog: {
    title: 'アシストアカウントを追加',
    inputName: 'Playturboアカウント名',
    successMessage: 'アシストアカウント追加成功',
  },
}
